import { useScrollAnimation, useScrollAnimationMultiple } from "@/hooks/useScrollAnimation";

const reasons = [
  { icon: "ri-leaf-line", title: "Eco-Friendly Planning", desc: "All our layouts are designed with green spaces, tree-lined roads, and sustainable infrastructure for a healthier lifestyle." },
  { icon: "ri-file-shield-2-line", title: "Documentation", desc: "Every project comes with complete legal documentation and full transparency — no hidden surprises." },
  { icon: "ri-map-pin-2-line", title: "Prime Sarjapur Road Location", desc: "All projects are on Sarjapur Road — one of Bengaluru's fastest-growing corridors." },
  { icon: "ri-shield-check-line", title: "Gated Community Security", desc: "24/7 security, CCTV surveillance, and controlled access ensure your family and investment are always protected." },
  { icon: "ri-customer-service-2-line", title: "Dedicated Support Team", desc: "From site visit to possession, our team is with you every step — responsive, transparent, and genuinely helpful." },
  { icon: "ri-line-chart-line", title: "Strong Investment Returns", desc: "Strategic locations near IT hubs ensure consistent property appreciation and strong long-term investment value." },
];

export default function WhyUs() {
  const { ref: headRef, isVisible: headVisible } = useScrollAnimation();
  const { setRef, visibleItems } = useScrollAnimationMultiple(reasons.length);

  return (
    <section className="bg-[#EAF5E1] py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div
          ref={headRef as (el: HTMLDivElement | null) => void}
          className={`text-center mb-12 reveal ${headVisible ? "visible" : ""}`}
        >
          <span className="inline-block text-xs font-bold uppercase tracking-widest text-[#7FBF3F] bg-white px-3 py-1.5 rounded-full mb-3 border border-[#7FBF3F]/20">
            Why Urban Infra
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-[#1B2A4A] mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>
            Why Choose Us
          </h2>
          <p className="text-gray-500 text-sm max-w-md mx-auto" style={{ fontFamily: "'Poppins', sans-serif" }}>
            We don&apos;t just sell plots — we build eco-friendly communities with trust, quality, and long-term value.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {reasons.map((reason, i) => (
            <div
              key={reason.title}
              ref={setRef(i) as (el: HTMLDivElement | null) => void}
              className={`card-hover group flex gap-4 bg-white border border-[#7FBF3F]/10 rounded-2xl p-6 reveal reveal-delay-${Math.min(i + 1, 6)} ${visibleItems[i] ? "visible" : ""}`}
              style={{ borderLeft: "4px solid #7FBF3F" }}
            >
              <div className="w-10 h-10 flex items-center justify-center bg-[#EAF5E1] rounded-xl flex-shrink-0 group-hover:bg-[#1B2A4A] transition-colors duration-300">
                <i className={`${reason.icon} text-lg text-[#7FBF3F] group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <div>
                <h3 className="font-semibold text-sm text-[#1B2A4A] mb-1.5" style={{ fontFamily: "'Poppins', sans-serif" }}>{reason.title}</h3>
                <p className="text-gray-500 text-xs leading-relaxed">{reason.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
